import React from 'react';
import '../styles/InvoiceSummary.css';

const InvoiceSummary = ({ total, onCompleteSale, onClearAll }) => {
  return (
    <>
      <div className="invoice-summary">
        <div className="summary-row">
          <span>Subtotal:</span>
          <span className="summary-value">{total} LKR</span>
        </div>
        <div className="summary-row">
          <span>Tax (0%):</span>
          <span className="summary-value">0.00 LKR</span>
        </div>
        <div className="summary-row total-row">
          <span>Total Amount:</span>
          <span className="total-value">{total} LKR</span>
        </div>
      </div>

      <div className="action-buttons">
        <button onClick={onCompleteSale} className="btn btn-large btn-primary">
          <span className="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
              <path d="M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z" />
              <path fillRule="evenodd" d="M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z" clipRule="evenodd" />
            </svg>
          </span>
          Complete Sale
        </button>
        <button onClick={onClearAll} className="btn btn-large btn-secondary">
          <span className="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
              <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z" clipRule="evenodd" />
            </svg>
          </span>
          Clear All
        </button>
      </div>
    </>
  );
};

export default InvoiceSummary;